<template>
<div class="system-set">
  <div class="m-b-20">
    <router-link class="btn-link-large add-btn" to="/home/administrative/groups-add">
      <i class="el-icon-plus"></i>&nbsp;&nbsp;添加用户组
    </router-link>
  </div>
  <el-table
  :data="tableData"
  style="width: 100%"
  @selection-change="selectItem">
    <el-table-column
    type="selection"
    width="50">
    </el-table-column>
    <el-table-column
    label="组名"
    prop="title">
    </el-table-column>
    <el-table-column
    label="描述"
    prop="remark">
    </el-table-column>
    <el-table-column
    label="状态"
    prop="status"
    width="100">
      <template slot-scope="scope">
        <div>
          {{ scope.row.status | status }}
        </div>
      </template>
    </el-table-column>
    <el-table-column
    label="操作"
    width="200">
      <!-- <template slot-scope="scope">
        <div>
          <span>
            <router-link :to="{ name: 'groupsEdit', params: { id: scope.row.id }}" class="btn-link edit-btn">
            编辑
            </router-link>
          </span>
          <span>
            <el-button
            size="small"
            type="danger"
            @click="confirmDelete(scope.row)">
            删除
            </el-button>
          </span>
        </div>
      </template>
    </el-table-column> -->
    <template slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
          <div class="op-link">
            <i class="iconfont icon-icon-bianji" style="font-size: 14px" @click="toEdit(scope.row.id)"></i>
          </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
          <div class="op-link">
            <i class="iconfont icon-icon-shanchu" style="font-size: 14px" @click="confirmDelete(scope.row)"></i>
          </div>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
  <div class="pos-rel p-t-20">
  </div>
</div>
</template>

<script>

export default {
  data() {
    return {
      tableData: [{}],
      multipleSelection: []
    }
  },
  methods: {
    toEdit(id) {
      router.push({name: 'userEdit', query: { id: id }})
    },
    selectItem(val) {
      this.multipleSelection = val
    },
    confirmDelete(item) {
      this.$confirm('确认删除该用户组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _g.openGlobalLoading()
      }).catch(() => {
        // handle error
      })
    },
    getgroups() {
    }
  },
  created() {
    this.getgroups()
  },
  computed: {
    addShow() {
      return _g.getHasRule('groups-save')
    },
    editShow() {
      return _g.getHasRule('groups-update')
    },
    deleteShow() {
      return _g.getHasRule('groups-delete')
    }
  },
  components: {
  }
}
</script>
